import { Button } from "components/Button/Button";
import { AutocompleteOption } from "components/Form/components/Autocomplete/Autocomplete";
import { CancelButton } from "components/Form/components/CancelButton/CancelButton";
import { Form } from "components/Form/components/Form/Form";
import { Input } from "components/Form/components/Input/Input";
import NotificationService from "components/Notification/Notification.service";
import { actions as resourcesActions } from "containers/Resources/Resources.reducer";
import { ActionData } from "containers/Resources/components/CommonActions/Action";
import { getSelectedLocationKey } from "containers/Resources/components/CommonActions/MoveToLocation/MoveResourcesToLocation";
import { MoveToLocationAutocomplete } from "containers/Resources/components/CommonActions/MoveToLocation/MoveToLocationAutocomplete";
import { useMoveToLocation } from "containers/Resources/components/CommonActions/MoveToLocation/useMoveToLocation";
import { Field, Form as FinalForm } from "react-final-form";
import { AnyAction, Dispatch } from "redux";
import { getRecordLocationId } from "utils/utils";

interface MoveToLocationFormComponentProps {
    data: ActionData;
    dispatch: Dispatch<AnyAction>;
    onCancel: () => void;
    onSuccess: (value?: unknown) => void;
    onError: (error: unknown) => void;
}

export const getLocationField = (selectedLocation?: AutocompleteOption) => {
    let locationField = {};
    if (selectedLocation) {
        if (selectedLocation.type === "workspace") {
            locationField = { project_id: null, bundle_id: null };
        } else {
            locationField = {
                [getSelectedLocationKey(selectedLocation.type!)]: selectedLocation.value,
            };
        }
    }
    return locationField;
};

export const moveToLocationAction = ({
    dispatch,
    resourceName,
    id,
    selectedLocation,
    iri,
}: {
    dispatch: any;
    resourceName: any;
    id: any;
    selectedLocation: any;
    iri?: string;
}) => {
    if (selectedLocation) {
        return new Promise((resolve, reject) => {
            const locationField = getLocationField(selectedLocation);
            return dispatch({
                type: resourcesActions.START_UPDATE_RESOURCE,
                promise: { resolve, reject },
                resourceName,
                iri,
                variables: {
                    id,
                    ...locationField,
                },
            });
        });
    }
};

export const MoveToLocationForm = ({
    data,
    dispatch,
    onCancel,
    onSuccess,
    onError,
}: MoveToLocationFormComponentProps) => {
    const recordLocationId = getRecordLocationId(data.resourceData);
    const { selectedLocation, changeValue, options, isSameLocation } = useMoveToLocation(
        data.resourceType
    );

    const moveToLocation = () => {
        if (selectedLocation) {
            moveToLocationAction({
                dispatch,
                resourceName: data.resourceType,
                id: data.resourceData?.id,
                selectedLocation,
                iri: data.iri,
            })
                ?.then(() => {
                    NotificationService.success(
                        `${data.resourceType} "${data.resourceData?.name}" updated successfully.`
                    );
                })
                .then(() => {
                    data?.afterAction?.();
                })
                .then((result) => onSuccess(result))
                .catch((error) => {
                    console.error(error);
                    onError(error);
                });
        }
    };

    return (
        <FinalForm onSubmit={moveToLocation}>
            {({ handleSubmit, pristine }) => {
                return (
                    <Form onSubmit={handleSubmit}>
                        <Form.Row>
                            <Field name="location" id={"location"}>
                                {({ input, fieldProps, fieldAttr, meta }) => {
                                    return (
                                        <Input
                                            fieldProps={fieldProps}
                                            fieldAttr={fieldAttr}
                                            input={input}
                                            meta={meta}
                                        >
                                            <MoveToLocationAutocomplete
                                                changeValue={(value) => {
                                                    changeValue(value);
                                                    input?.onChange(value);
                                                }}
                                                value={selectedLocation?.value}
                                                options={options}
                                                name={input.name}
                                                recordLocationId={recordLocationId}
                                            />
                                        </Input>
                                    );
                                }}
                            </Field>
                        </Form.Row>
                        <Form.Row className="sign-in--offset">
                            <CancelButton onClick={onCancel} />
                            <Button submit label="OK" disabled={pristine || isSameLocation} />
                        </Form.Row>
                    </Form>
                );
            }}
        </FinalForm>
    );
};
